import axios from 'axios'
import { queryHourlyStatus } from '@/setting/queryText'

async function getDataSeries (_Date) {
  const _data = JSON.stringify({
    query: queryHourlyStatus.replace('$date', `"${_Date}"`)
  })
  const _config = {
    method: 'post',
    url: 'https://p2ha77gfjzhl7nbjoiwolwmleu.appsync-api.ap-southeast-1.amazonaws.com/graphql',
    headers: {
      'x-api-key': 'da2-dnzqionk6jc7fjd5ieqfehqz54',
      'Content-Type': 'application/json'
    },
    data: _data
  }
  const _temp = await axios(_config).then(function (response) {
    console.log('ssssssss', response)
    return response
  })
  return _temp
}

function arrayReturn (_arr) {
  // console.log(_arr)
  const _dataraw = []
  for (const i in _arr) {
    if (_arr[i][1] === undefined) {
      _dataraw.push([null, null, null, null, null])
    } else {
      _dataraw.push([_arr[i][1].progressOrder, _arr[i][1].successOrder])
    }
    // console.log(_dataraw)
  }
  return _dataraw
}

function sortedData (_intputArr) {
  const arrLenght = _intputArr.data.data.getDateTimebyDate.items.length
  // console.log(arrLenght)
  const tempArr = []
  for (let i = 0; i < arrLenght; i++) {
    tempArr.push([_intputArr.data.data.getDateTimebyDate.items[i].dateTime,
      _intputArr.data.data.getDateTimebyDate.items[i].statusesHour.items[0]])
  }
  // console.log('tempArr', tempArr)
  return arrayReturn(tempArr)
}

const initialState = {
  status: null
}
const currentStatHour = {
  namespaced: true,
  state: initialState,
  getters: {
    status: (state) => {
      return state.status
    }
  },
  mutations: {
    setStatus (state, val) {
      state.status = val
    }
  },
  actions: {
    async getStatus (context, _date) {
      const temp = sortedData(await getDataSeries(_date))
      context.commit('setStatus', temp)
    }
  }

}

export default currentStatHour
